<template>
	<div class="video-text-rewrite-page">
		<!-- 导航栏：与AI创作页面一致，无右侧按钮 -->
		<div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
			<div class="back-btn" @click="onBack">
				<img src="@/assets/back.svg" class="back-icon" />
			</div>
			<div class="nav-title">AI改写</div>
		</div>

		<!-- 主体区域：与AI创作页面一致，仅新增取消按钮 -->
		<div class="page-body">
			<!-- AI改写模块：标题改为AI改写，生成文案左侧加取消按钮 -->
			<div class="result-section">
				<div class="section-header">
					<div class="section-title">AI改写</div>
					<!-- 取消+生成文案按钮组 -->
					<div class="rewrite-btn-group">
						<!-- 始终显示取消按钮 -->
						<div v-if="!isGenerated" class="cancel-btn" @click="handleCancel">
							取消
						</div>

						<!-- 未生成：显示生成文案按钮 -->
						<div v-if="!isGenerated" class="generate-btn" @click="handleGenerateText"
							>
							生成文案
						</div>

						<!-- 已生成：显示重新生成+应用按钮 -->
						<div v-else class="generate-result-btn-group">
							<div class="regenerate-btn" @click="handleRegenerate">
								重新生成
							</div>
							<div class="apply-btn" @click="handleApply">
								应用
							</div>
						</div>
					</div>
				</div>
				<!-- 文本框：与AI创作页面完全一致 -->
				<textarea class="content-input" v-model="content" placeholder="请输入您的改写要求，没有具体想法可不填"
					@input="handleContentInput">
				</textarea>
			</div>

			<!-- 时长选择模块：与AI创作页面完全一致 -->
			<div class="duration-select-wrapper" ref="durationWrapper" @click.stop="toggleDurationDropdown">
				<div class="duration-select-box">
					<div class="duration-text">{{ selectedDuration.text }}</div>
					<img :src="isDropdownOpen ? require('@/assets/aiVideo/arrow_up.png') : require('@/assets/aiVideo/arrow_down.png')"
						class="arrow-icon" alt="arrow" />
				</div>
				<div class="duration-dropdown" v-if="isDropdownOpen">
					<div class="duration-item" v-for="item in durationOptions" :key="item.value"
						:class="{active: item.value === selectedDuration.value}" @click.stop="selectDuration(item)">
						{{ item.text }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		scriptCreate
	} from "@/api/poster";
	export default {
		name: "VideoTextRewritePage",
		data() {
			return {
				content: "", // 文本框内容
				message: '',
				isDropdownOpen: false, // 时长下拉框是否展开
				// 时长枚举：与AI创作页面一致
				durationOptions: [{
						text: '视频30秒（约100个字）',
						value: "100" // 原30 → 改为"100"
					},
					{
						text: '视频1分钟（约200个字）',
						value: "200" // 原60 → 改为"200"
					},
					{
						text: '视频1分30秒（约300个字）',
						value: "300" // 原90 → 改为"300"
					},
					{
						text: '视频2分钟（约400个字）',
						value: "400" // 原120 → 改为"400"
					}
				],
				selectedDuration: {
					text: '视频1分钟（约200个字）',
					value: "200"
				},
				isGenerated: false, // 标记是否已生成文案（与AI创作页面一致）
				currentPlatform: '',
			};
		},
		mounted() {
			document.title = "AI改写";
			const {
				content
			} = this.$route.query;
			if (content) {
				this.message = content; // 将路由参数的content填充到data中
			}
			// 可选：从路由参数获取需要改写的文案内容
			// const { content } = this.$route.query;
			// if (content) this.content = content;
			this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
			// 监听全局点击关闭下拉框（与AI创作页面一致）
			document.addEventListener('click', this.handleClickOutside);
		},
		beforeDestroy() {
			// 销毁全局点击监听（与AI创作页面一致）
			document.removeEventListener('click', this.handleClickOutside);
		},
		methods: {
			// 返回按钮（与AI创作页面一致）
			onBack() {
				this.$router.back();
			},
			// 新增：取消按钮逻辑（返回上一页）
			handleCancel() {
				this.$router.back();
			},
			// 文本框输入事件（与AI创作页面一致）
			handleContentInput() {},
			// 切换时长下拉框（与AI创作页面一致）
			toggleDurationDropdown() {
				this.isDropdownOpen = !this.isDropdownOpen;
			},
			// 选择时长选项（与AI创作页面一致）
			selectDuration(item) {
				this.$nextTick(() => {
					this.selectedDuration = item;
					this.isDropdownOpen = false;
				});
			},
			// 处理外部点击关闭下拉框（与AI创作页面一致）
			handleClickOutside(e) {
				if (this.$refs.durationWrapper && !this.$refs.durationWrapper.contains(e.target)) {
					this.isDropdownOpen = false;
				}
			},
			// 生成文案逻辑（与AI创作页面一致）
			async handleGenerateText() {
				let param;
				if(this.isGenerated){
					param = {
						text: this.content,
						type: 'rewrite',
						requirement: '',
						num: this.selectedDuration.value 
					}
				}else{
					param = {
						text: this.message,
						type: 'rewrite',
						requirement: this.content,
						num: this.selectedDuration.value 
					}
				}
				
				
				try {
					const res = await scriptCreate(param);
					console.log('请求结果', res);
					if(res){
						this.content = res.text
						this.isGenerated = true
					}
					
				} catch (error) {
					console.log(error);
				}
			},
			// 重新生成按钮逻辑（与AI创作页面一致）
			handleRegenerate() {
				this.handleGenerateText();
			},
			// 应用按钮逻辑（与AI创作页面一致）
			handleApply() {
				sessionStorage.setItem('rewriteContent', JSON.stringify(this.content));
				this.$router.back();
			}
		}
	};
</script>

<style scoped>
	/* 页面基础布局：与AI创作页面完全一致 */
	.video-text-rewrite-page {
		width: 100vw;
		height: 100vh;
		height: 100dvh;
		background: #f5f6f8;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
	}

	/* 导航栏：与AI创作页面完全一致 */
	.custom-nav-bar {
		width: 100%;
		height: 11.7333vw;
		background-image: linear-gradient(90deg, #E7F2FA 0%, #DBE2F1 100%);
		box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
		position: relative;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		flex-shrink: 0;
	}

	.back-btn {
		width: 6.4vw;
		height: 6.4vw;
		position: absolute;
		left: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-title {
		font-family: SourceHanSansSC-Medium;
		font-size: 4.8vw;
		color: #000000;
		letter-spacing: 0.1333vw;
		text-align: center;
		line-height: 11.7333vw;
		font-weight: 500;
	}

	/* 主体区域：与AI创作页面完全一致 */
	.page-body {
		padding: 5.3333vw 4.8vw;
		box-sizing: border-box;
		background: #FFFFFF;
		flex: 1;
		min-height: 0;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.result-section {
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	/* 标题头部：调整按钮组布局（新增取消按钮） */
	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 1.6vw;
		flex-shrink: 0;
	}

	.section-title {
		opacity: 0.9;
		font-family: SourceHanSansSC-bold;
		color: #1F2226;
		font-weight: 700;
		font-size: 4.2667vw;
		letter-spacing: -0.1333vw;
		font-style: normal;
		text-decoration: none;
		text-align: left;
	}

	/* 取消+生成文案按钮组 */
	.rewrite-btn-group {
		display: flex;
		gap: 1.6vw;
		/* 按钮间距12px */
		align-items: center;
	}

	/* 取消按钮样式：与生成文案按钮风格一致 */
	.cancel-btn {
		padding: 0.8vw 2.4vw;
		height: 5.3333vw;
		width: auto;
		display: flex;
		align-items: center;
		gap: 0.8vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #FFFFFF;
		border: 0.2667vw solid #1570EE;
		cursor: pointer;
		box-sizing: border-box;
		font-family: SourceHanSansSC-regular;
		color: #2C7EEF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
	}

	/* 生成文案按钮样式：与AI创作页面完全一致 */
	.generate-btn {
		padding: 0.8vw 2.4vw;
		height: 5.3333vw;
		width: auto;
		display: flex;
		align-items: center;
		gap: 0.8vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #1570EE;
		cursor: pointer;
		box-sizing: border-box;
		font-family: SourceHanSansSC-regular;
		color: #FFFFFF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
	}

	.generate-btn.disabled {
		background-color: #EBEBED;
		color: #666666;
		cursor: not-allowed;
		opacity: 0.7;
	}

	/* 生成结果按钮组（重新生成+应用）：与AI创作页面一致 */
	.generate-result-btn-group {
		display: flex;
		gap: 1.6vw;
		align-items: center;
	}

	.regenerate-btn {
		padding: 0.8vw 2.6667vw;
		height: 5.3333vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #FFFFFF;
		border: 0.2667vw solid #1570EE;
		font-family: SourceHanSansSC-regular;
		color: #2C7EEF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
	}

	.apply-btn {
		padding: 0.8vw 2.4vw;
		height: 5.3333vw;
		border-radius: 2.6667vw;
		opacity: 0.9;
		background-color: #1570EE;
		font-family: SourceHanSansSC-regular;
		color: #FFFFFF;
		font-weight: 400;
		font-size: 2.6667vw;
		font-style: normal;
		text-decoration: none;
		text-align: center;
		line-height: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
	}

	/* 文本框样式：与AI创作页面完全一致 */
	.content-input {
		width: 100%;
		flex: 1;
		height: calc(100% - 21.8667vw);
		padding: 2.6667vw 3.2vw;
		border-radius: 2.1333vw;
		border: 0.2667vw solid #D2DAE4;
		box-shadow: 0px -0.2667vw 0px 0px rgba(228, 232, 236, 1);
		font-family: SourceHanSansSC-medium;
		font-size: 3.2vw;
		color: #333333;
		outline: none;
		resize: none;
		box-sizing: border-box;
		background: #FFFFFF;
		line-height: 1.5;
		overflow-y: auto;
	}

	/* 时长选择模块：与AI创作页面完全一致 */
	.duration-select-wrapper {
		margin-top: 2.6667vw;
		width: 48.5333vw;
		position: relative;
		flex-shrink: 0;
	}

	.duration-select-box {
		width: 100%;
		height: 8vw;
		border-radius: 2.1333vw;
		border: 0.2667vw solid #D2DAE4;
		box-sizing: border-box;
		padding: 1.6vw 2.6667vw;
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
	}

	.duration-text {
		font-family: SourceHanSansSC-medium;
		font-size: 3.2vw;
		color: #333333;
	}

	.arrow-icon {
		width: 3.2vw;
		height: 3.2vw;
		object-fit: contain;
	}

	.duration-dropdown {
		position: absolute;
		bottom: calc(100% + 1.0667vw);
		left: 0;
		width: 48.5333vw;
		border-radius: 2.1333vw;
		border: 0.2667vw solid #D2DAE4;
		box-shadow: 0px 0px 0.5333vw 0px rgba(0, 0, 0, 0.2);
		background-color: #FFFFFF;
		z-index: 99;
	}

	.duration-item {
		height: 8vw;
		box-sizing: border-box;
		padding: 0 2.6667vw;
		display: flex;
		align-items: center;
		border-bottom: 0.1333vw solid #F0F0F0;
		font-size: 3.2vw;
		line-height: 4.5333vw;
	}

	.duration-item:last-child {
		border-bottom: none;
	}

	.duration-item {
		font-family: SourceHanSansSC-regular;
		color: #333333;
		font-weight: 400;
		font-style: normal;
		text-decoration: none;
	}

	.duration-item.active {
		font-family: SourceHanSansSC-medium;
		color: #1570EE;
		font-weight: 500;
		background-color: #F6F9FB;
	}
</style>